enum NewSurveyScreen {
    LOADING = '@@newSurveyScreen/LOADING',
    ERROR = '@@newSurveyScreen/ERROR',
    ANALYSIS_RESULTS = '@@newSurveyScreen/ANALYSIS_RESULTS',
}

export default NewSurveyScreen;
